import { useApiUrl as c, useCustomMutation as r } from "@refinedev/core";
import { message as n } from "antd";
const p = ({ form: e, url: t }) => {
  const s = c(), o = r(), { mutate: a } = o;
  return {
    handleSave: () => {
      n.loading({
        content: "儲存中...",
        duration: 0,
        key: "save"
      }), e.validateFields().then((i) => {
        a(
          {
            url: t || `${s}/options`,
            // 預設 API 路徑
            method: "post",
            values: i
          },
          {
            onSuccess: () => {
              n.success({
                content: "儲存成功",
                key: "save"
              }), window.confirm(
                `
儲存成功，需要重新整理頁面後才能使用

按【確認】重新整理頁面`
              ) && window.location.reload();
            }
          }
        );
      });
    },
    mutation: o
  };
};
export {
  p as useSave
};
